// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
// 引入element
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);
//引入axios
/*import axios from 'axios';
Vue.prototype.$axios = axios;
// 全局定义接口前缀
let serverUrl = '/api/'; //本地调试
//let serverUrl = 'http://tgl.com/'; //打包部署上线地址
Vue.prototype.url = serverUrl;*/
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'L8TrYxgExmr3uECQqTkV2FqRwVmpKDUX'
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js